








































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";

import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import { ICustomerGroup, IPagination, ITableParams } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox
  }
})
export default class Groups extends Vue {
  public loading = false;
  public updating = false;
  private groups: Array<ICustomerGroup> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private selectedGroupId: string | null = null;
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.group_deleted === "true") {
        swal("Success!", "The group was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getGroups(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.group_deleted === true) {
      swal("Success!", "The group was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getGroups(() => {
      //
    });
    next();
  }

  private getGroups(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.groups = [];
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.groups = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteGroup(groupId: string): void {
    this.selectedGroupId = groupId;
    if (this.loading || this.updating || this.selectedGroupId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The group will be deleted.",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "groups/" + this.selectedGroupId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "GroupsOverview",
                query: { group_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The group was deleted.", "success");
                  this.getGroups(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete groups.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
